module.exports = __webpack_public_path__ + "files/832c29503d17205af70eb414a5eaad68.png";